import profilePage from '../profile/_id.vue';
export default profilePage;
